import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryKeys";
import { Avatar } from "@/components/Avatar";

/**
 * Project Members tab — full roster (role + email) for the project, served
 * by GET /api/projects/:projectId/members. The project breadcrumb, header
 * and tab strip live in the parent layout route (`route.tsx`); this view
 * renders content only.
 */
function MembersPage() {
  const { projectId } = Route.useParams();
  const membersQ = useQuery({
    queryKey: queryKeys.projectMembers(projectId),
    queryFn: () => api.projectMembers(projectId),
  });
  return (
    <div className="proj-shell-content">
      <div className="panel">
        <div className="panel-body">
          {membersQ.isLoading ? (
            <p>Loading…</p>
          ) : (
            <ul
              className="members-list"
              style={{ listStyle: "none", padding: 0, margin: 0 }}
            >
              {(membersQ.data?.members ?? []).map((m) => (
                <li
                  key={m.userId}
                  className="member-row"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "12px 0",
                    borderBottom: "1px solid var(--border)",
                  }}
                >
                  <Avatar id={m.userId} name={m.name ?? m.email} size={36} />
                  <div>
                    <div style={{ fontWeight: 500 }}>{m.name ?? m.email}</div>
                    <div className="t-muted" style={{ fontSize: 13 }}>
                      {m.role === "owner" ? "Owner" : "Member"} · {m.email}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/projects/$projectId/members")({
  component: MembersPage,
});
